import { createFileRoute } from '@tanstack/react-router'
import StudentScoreDetails from '@/components/adminPage/student/StudentScoreDetails'

export const Route = createFileRoute(
  '/admin/database/student-score-details/$studentId'
)({
  component: StudentScoreDetailsPage,
})

function StudentScoreDetailsPage() {
  const { studentId } = Route.useParams()
  return <StudentScoreDetails studentId={studentId} />
}
